export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -90, duration: 1.25 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const scrollToTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.1 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
};
